// extracted by mini-css-extract-plugin
export default {"error_page":"ErrorPage_error_page__+HMvF","error_message_container":"ErrorPage_error_message_container__k8No9","back_btn":"ErrorPage_back_btn__dEWBQ"};